import React from "react";
import PropTypes from "prop-types";
import TooltipButton from "../../ui/tooltip-button";

const ExpandButton = ({ toggleRow, isExpanded }) => (
  <TooltipButton
    onClick={e => toggleRow(e)}
    buttonClassName="btn-action"
    iconClassName={isExpanded ? "icono-arrow-up-simple" : "icono-arrow-down-simple"}
    tooltipText={isExpanded ? "Colapsar detalle" : "Expandir detalle"}
  />
);

ExpandButton.propTypes = {
  toggleRow: PropTypes.func,
  isExpanded: PropTypes.bool
};

ExpandButton.defaultProps = {
  toggleRow: () => {},
  isExpanded: false
};
export default ExpandButton;
